import { render, staticRenderFns } from "./AboutPageAvailableData.vue?vue&type=template&id=e1c440b6&scoped=true"
import script from "./AboutPageAvailableData.vue?vue&type=script&lang=js"
export * from "./AboutPageAvailableData.vue?vue&type=script&lang=js"
import style0 from "./AboutPageAvailableData.vue?vue&type=style&index=0&id=e1c440b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c440b6",
  null
  
)

export default component.exports